export const dealerships = [
  { PACode: 'Ford Direct', BusinessName: 'Ford Direct' },
  { PACode: 'unspecified', BusinessName: 'unspecified' },

  //   { PACode: "04786", BusinessName: "Price Ford of Turlock" },
  //   { PACode: "01915", BusinessName: "North East Ford" },
  //   { PACode: "04885", BusinessName: "Chipola Ford" },
  //   { PACode: "04446", BusinessName: "Hacienda Ford" },
  //   { PACode: "02459", BusinessName: "Sam Pack's Five Star Ford Carrollton" },
  //   { PACode: "05706", BusinessName: "Al White Motors, Inc." },
  //   { PACode: "04947", BusinessName: "Walker Ford Company, Inc." },
  //   { PACode: "02486", BusinessName: "Five Star Ford North Richland Hills" },
  //   { PACode: "03161", BusinessName: "Keesee Motor Co" },
  //   { PACode: "07782", BusinessName: "W. C. Sanderson Ford" },
  //   { PACode: "09448", BusinessName: "Jenkins Ford, LLC" },
  //   { PACode: "20107", BusinessName: "Finnin Ford" },
  //   { PACode: "04548", BusinessName: "San Augustine Motor Co" },
  //   { PACode: "07734", BusinessName: "Fahrney Ford Sales" },
  //   { PACode: "05485", BusinessName: "Raceway Ford" },
  //   { PACode: "07175", BusinessName: "Diers Ford" },
  //   { PACode: "01172", BusinessName: "Sun State Ford Inc" },
  //   { PACode: "20307", BusinessName: "Rich Ford Sales, Inc." },
  //   { PACode: "05749", BusinessName: "Monarch Ford" },
  //   { PACode: "04626", BusinessName: "Golf Mill Motor Sales, Inc." },
  //   { PACode: "05536", BusinessName: "Galpin Ford" },
  //   { PACode: "09624", BusinessName: "Stillwell Ford" },
  //   { PACode: "02091", BusinessName: "Planet Ford" },
  //   { PACode: "04462", BusinessName: "Randall Reed's Planet Ford" },
  //   { PACode: "05475", BusinessName: "Encinitas Ford" },
  //   { PACode: "00391", BusinessName: "Hillsboro Ford, LLC" },
  //   { PACode: "01111", BusinessName: "Doggett Ford" },
  //   { PACode: "05508", BusinessName: "Theodore Robins Ford" },
  //   { PACode: "07777", BusinessName: "Future Ford of Clovis" },
  //   { PACode: "07749", BusinessName: "Future Ford of Roseville" },
  //   { PACode: "07884", BusinessName: "Future Ford" },
  //   { PACode: "08985", BusinessName: "Hacienda Ford of Alice" },
  //   { PACode: "07967", BusinessName: "Sam Pack's Five Star Ford of Lewisville" },
  //   { PACode: "04593", BusinessName: "Chaparral Ford Inc" },
  //   { PACode: "08760", BusinessName: "Mac Haik Ford" },
  //   { PACode: "02434", BusinessName: "Columbine Ford" },
  //   { PACode: "05126", BusinessName: "Gary Crossley Ford, LLC" },
  //   { PACode: "01660", BusinessName: "Hillsboro Ford Inc" },
  //   { PACode: "05471", BusinessName: "Jim Burke Ford" },
  //   { PACode: "07444", BusinessName: "Five Star Ford of Dallas" },
  //   { PACode: "04854", BusinessName: "Doggett Ford of Beaumont" },
  //   { PACode: "05395", BusinessName: "Hemborg Ford" },
  //   { PACode: "06985", BusinessName: "Mac Haik's Southway Ford" },
  //   { PACode: "02631", BusinessName: "Karl Klement Ford" },
  //   { PACode: "09473", BusinessName: "Tenvoorde Ford, Inc." },
  //   { PACode: "02861", BusinessName: "Lake Hartwell Ford" },
  //   { PACode: "08662", BusinessName: "Skyline Sales, Inc." },
  //   { PACode: "08729", BusinessName: "Damerow Ford" },
  //   { PACode: "02463", BusinessName: "Bill Utter Ford" },
  //   { PACode: "00779", BusinessName: "Glenn Polk Ford" },
  //   { PACode: "04643", BusinessName: "Brad Howell, Inc." },
  //   { PACode: "05005", BusinessName: "Zink Motor Co Inc" },
  //   { PACode: "03174", BusinessName: "Whittaker Ford, Inc." },
  //   { PACode: "05472", BusinessName: "Colley" },
  //   { PACode: "04863", BusinessName: "Duval Ford" },
  //   { PACode: "01286", BusinessName: "Tamiami Ford Inc" },
  //   { PACode: "04500", BusinessName: "Appel Ford, Inc." },
  //   { PACode: "06546", BusinessName: "T & J Ford, Inc." },
  //   { PACode: "08223", BusinessName: "Link Ford & RV - Minong, LLC" },
  //   { PACode: "08220", BusinessName: "Link Ford and RV-Rice Lake LLC" },
  //   { PACode: "01892", BusinessName: "Webb Ford, Inc." },
  //   { PACode: "20360", BusinessName: "Bell Ford" },
  //   { PACode: "06584", BusinessName: "Englewood Ford" },
  //   { PACode: "07457", BusinessName: "Chenoweth Ford Inc" },
  //   { PACode: "01969", BusinessName: "Empire Ford" },
  //   { PACode: "07164", BusinessName: "Hacienda Ford of Kingsville" },
  //   { PACode: "03627", BusinessName: "Timberland Ford" },
  //   { PACode: "03934", BusinessName: "Fairway Ford" },
  //   { PACode: "09469", BusinessName: "Randall Reed's Planet Ford 635" },
  //   { PACode: "07504", BusinessName: "Gillespie Ford" },
  //   { PACode: "05497", BusinessName: "Sunland Ford" },
  //   { PACode: "08199", BusinessName: "Dave Sinclair Ford, Inc." },
  //   { PACode: "07313", BusinessName: "Washington Ford Inc" },
  //   { PACode: "07467", BusinessName: "Woltz & Wind Ford, Inc." },
  //   { PACode: "01521", BusinessName: "Friendly Ford, Inc." },
  //   { PACode: "00399", BusinessName: "Barber-Dyson Ford of Woodward" },
  //   { PACode: "05755", BusinessName: "Town and Country Ford, LLC" },
  //   { PACode: "05400", BusinessName: "Jim Charlon Ford, Inc." },
  //   { PACode: "05030", BusinessName: "Foss Motor Co., Inc." },
  //   { PACode: "01762", BusinessName: "Shults Ford Wexford" },
  //   { PACode: "06338", BusinessName: "Shults Ford Harmarville" },
  //   { PACode: "04682", BusinessName: "Shults Ford South" },
  //   { PACode: "04796", BusinessName: "Shults Ford Wheeling" },
  //   { PACode: "00967", BusinessName: "Stott's Ford Inc" },
  //   { PACode: "00107", BusinessName: "Sam Wampler's Freedom Ford Eufaula" },
  //   { PACode: "04898", BusinessName: "Sam Wampler's Freedom Ford" },
  //   { PACode: "08488", BusinessName: "Cook Ford" },
  //   { PACode: "00204", BusinessName: "Butler Ford" },
  //   { PACode: "09082", BusinessName: "Place Motor, Inc." },
  //   { PACode: "08413", BusinessName: "Archie Cochrane Motors, Inc." },
  //   { PACode: "02418", BusinessName: "Blake Fulenwider Ford of Andrews" },
  //   { PACode: "03591", BusinessName: "Matthews-Currie Ford Company" },
  //   { PACode: "04963", BusinessName: "Brandon Ford" },
  //   { PACode: "04600", BusinessName: "Bud Cross Ford, Inc." },
  //   { PACode: "20301", BusinessName: "Sanderson Ford" },
  //   { PACode: "05368", BusinessName: "Harrisonburg Ford, Inc." },
  //   { PACode: "08622", BusinessName: "Northside Ford Truck Sales, Inc." }
]
